// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomCheckbox_container___n-Gg","Signup":"CustomCheckbox_Signup__3EvFQ","checkmark":"CustomCheckbox_checkmark__3QD3k"};